export default __webpack_public_path__ + "static/media/tenth-strip.820aab28.png";